import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 146 146" xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd"
  }}><circle cx={72.658} cy={72.658} r={58.227} style={{
      fill: "none",
      stroke: "#fff",
      strokeWidth: 7
    }} /><path d="M58.21 68.842L71.266 81.85l21.091-21.013" style={{
      fill: "none",
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 7,
      strokeLinecap: "round"
    }} /></svg>;
}
export default SvgComponent;